<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path
            fill="currentColor"
            d="M3.333 14.667V1.333h1.334v1.334H14L12.667 6 14 9.333H4.667v5.334H3.333Zm5-7.334c.367 0 .68-.13.942-.391.261-.261.392-.575.392-.942s-.131-.68-.392-.942a1.284 1.284 0 0 0-.942-.391c-.366 0-.68.13-.941.391A1.284 1.284 0 0 0 7 6c0 .367.13.68.392.942.26.26.575.391.941.391ZM4.667 8h7.366l-.8-2 .8-2H4.667v4Z"
        />
    </svg>
</template>

<script setup lang="ts">
type TourIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<TourIconProps>();
</script>
